export interface ImprimirDivOptions {
  titulo?: string;
  subtitulo?: string;
}

export function escapeHtml(text: string): string {
  const el = document.createElement('div');
  el.textContent = text;
  return el.innerHTML;
}

function cabecalhoImpressao(options?: ImprimirDivOptions): string {
  if (!options?.titulo && !options?.subtitulo) return '';

  return `
    <div class="impressao-cabecalho">
      ${options.titulo ? `<h1>${escapeHtml(options.titulo)}</h1>` : ''}
      ${options.subtitulo ? `<h2>${escapeHtml(options.subtitulo)}</h2>` : ''}
    </div>
  `;
}

const ESTILOS_IMPRESSAO_TABELA = `
  <style>
    @page { margin: 1.5cm; }
    * { box-sizing: border-box; }
    body {
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      font-size: 11pt;
      color: #000;
      margin: 0;
      padding: 0;
    }
    .impressao-cabecalho {
      text-align: center;
      margin-bottom: 1rem;
      padding-bottom: 0.5rem;
      border-bottom: 1px solid #ccc;
    }
    .impressao-cabecalho h1 {
      font-size: 16pt;
      margin: 0 0 0.25rem;
      font-weight: 600;
    }
    .impressao-cabecalho h2 {
      font-size: 12pt;
      margin: 0;
      font-weight: 400;
      color: #333;
    }
    table {
      width: 100%;
      border-collapse: collapse !important;
      margin: 0 !important;
      table-layout: auto;
    }
    thead { display: table-header-group; }
    tbody { display: table-row-group; }
    tr { page-break-inside: avoid; break-inside: avoid; }
    th, td {
      border: 1px solid #333 !important;
      padding: 5px 8px !important;
      vertical-align: middle !important;
      text-align: center;
      background: #fff !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    thead th {
      background: #e9ecef !important;
      font-weight: 600;
    }
    .relatorio-solar-cabecalho img { width: 72px; max-width: 72px; height: auto; }
    .d-print-none { display: none !important; }
    a { color: inherit !important; text-decoration: none !important; }
  </style>
`;

/**
 * Imprime um conteúdo HTML já montado em nova janela de impressão.
 * @param conteudoHtml HTML do corpo (ex.: tabelas geradas a partir dos dados).
 * @param options título e subtítulo opcionais exibidos acima do conteúdo.
 */
export function imprimirHtml(conteudoHtml: string, options?: ImprimirDivOptions) {
  const innerHTML = `<!DOCTYPE html>
   <html lang="pt-BR">
   <head>
   <meta charset="utf-8" />
   <meta name="viewport" content="width=device-width, initial-scale=1.0" />
   <title>${escapeHtml(options?.titulo ?? options?.subtitulo ?? 'Impressão')}</title>
   ${ESTILOS_IMPRESSAO_TABELA}
   </head>
   <body>
   ${cabecalhoImpressao(options)}
   ${conteudoHtml}
   </body>
   </html>`;

  const frame = window.document.createElement('iframe');
  frame.style.height = '0px';
  frame.style.width = '0px';
  frame.style.position = 'absolute';
  document.body.appendChild(frame);

  const conteudo = frame.contentWindow!;
  conteudo.document.open();
  conteudo.document.write(innerHTML);
  conteudo.document.close();

  const imprimir = () => {
    conteudo.focus();
    conteudo.print();
    window.setTimeout(() => frame.remove(), 1000);
  };

  if (conteudo.document.readyState === 'complete') {
    window.setTimeout(imprimir, 150);
  } else {
    frame.onload = () => window.setTimeout(imprimir, 150);
  }
}

/**
 * Imprime o conteúdo de uma div em nova janela de impressão.
 * @param divname id do elemento.
 * @param options título e subtítulo opcionais exibidos acima do conteúdo.
 */
export default function imprimirDiv(divname: string, options?: ImprimirDivOptions) {
  const div = document.getElementById(divname);
  if (!div) return;

  imprimirHtml(div.innerHTML, options);
}
